$(document).ready(function () {
    /*Dropdown cart*/
    $(document).on("click", ".site-header__cart .fa-shopping-bag, .site-header__cart .site-header__cart-count", function () {
        $('.site-header__cart .cart_dropdown').toggleClass('active');
    });
    $(document).click(function (e) {
        var container = $(".site-header__cart");
        if (!container.is(e.target) && container.has(e.target).length === 0 && $('.site-header__cart .cart_dropdown').hasClass('active')) {
            $('.site-header__cart .cart_dropdown').removeClass('active');
        }
    });

    // Home search toggle and footer toggle
    if($(window).width() < 767 ){
        $('.site-footer__content .block_item .have_text').click(function(){
            $(this).toggleClass('open');
            $(this).next().slideToggle();
        })
    }

    // Homepage
    $('.template-index .slide-testimonial').slick({
        asNavFor: '.template-index .slider-for',
        dots: false,
        arrows:  true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 25000,
    });
    $('.template-index .slider-for').slick({
        asNavFor: '.template-index .slide-testimonial',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 25000,
        arrows: false
    });
    
    alignHeight('.template-index .product-card .grid-view-item__title ');

    // Add class to body product manager
    if($(".product-single .product_manager_button").length > 0){
        $('body').addClass("template-product-manager");
    }

    /*Ajax Remove product cart*/
    $(document).on("click", ".site-header__cart .cart_dropdown .items .item .action a", function (event) {
        event.preventDefault();
        var removeCartUrl = $(this).attr('href');
        $(".alert_addtocart").removeClass('active error');
        $('.site-header__cart .ajax-loader').show();
        $.ajax({
            type: 'GET',
            url: removeCartUrl,
            success: function (response) {
                $('.site-header__cart .ajax-loader').hide();
                var headerCartHtml = $(response).find('.site-header__cart').first().html();
                if (headerCartHtml) {
                    $('.site-header .site-header__cart').html(headerCartHtml);
                }
                if ($('body').hasClass('template-cart')) {
                    location.reload();
                }
            },
            error: function (XMLHttpRequest) {
                $('.site-header__cart .ajax-loader').hide();
                var data = eval('(' + XMLHttpRequest.responseText + ')');
                var errorMessage = '';
                if (!!data.message) {
                    errorMessage = data.description
                } else {
                    errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
                }
                $(".alert_addtocart .error_p").text(errorMessage);
                $(".alert_addtocart").addClass('active error');
            }
        });
    });
    /*Ajax Add to Cart*/
    $("form[action='/cart/add'] [type=submit]").on("click", function (e) {
        e.preventDefault();
        $(".alert_addtocart").removeClass('active error');
        var number = $('input[name="quantity"]').val();
        if (number == 0 || number == "") {
            $(".alert_addtocart .error_p").text("The number of products must be greater than 0");
            $(".alert_addtocart").addClass('active error');
        } else {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: $('form[action="/cart/add"]').serialize(),
                dataType: 'json',
                success: function (data) {
                    $.ajax({
                        url: data.url,
                        type: "GET",
                        dataType: 'html',
                        success: function (response) {
                            //get and chang number item in icon cart
                            var headerCartHtml = $(response).find('.site-header__cart').first().html();
                            if (headerCartHtml) {
                                $('.site-header .site-header__cart').html(headerCartHtml);
                            }
                        }
                    });
                    $(".alert_addtocart").addClass('active success');
                },
                error: function (XMLHttpRequest) {
                    //get message error in api ajax default Shopify
                    var data = eval('(' + XMLHttpRequest.responseText + ')');
                    var errorMessage = '';
                    if (!!data.message) {
                        errorMessage = data.description
                    } else {
                        errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
                    }
                    $(".alert_addtocart .error_p").text(errorMessage);
                    $(".alert_addtocart").addClass('active error');
                }
            });
        }
    });
    /*Close popup add to cart*/
    $(document).on("click", ".alert_addtocart i", function (event) {
        $(this).parent().removeClass('active');
    });

    $('.slide_thumbail').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: '.slider_nav_thumbnails',
        dots: false,
        nextArrow: '<i class="fal fa-chevron-right"></i>',
        prevArrow: '<i class="fal fa-chevron-left"></i>',
    });
    $('.slider_nav_thumbnails').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slide_thumbail',
        dots: false,
        focusOnSelect: true,
        arrows: false,
    });
    $('.slide_thumbail_popup').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        dots: false,
        nextArrow: '<i class="fal fa-chevron-right"></i>',
        prevArrow: '<i class="fal fa-chevron-left"></i>',
    });
    /*Slide Product recomentdation*/
    var interval_obj = setInterval(function () {
        if ($('#shopify-section-product-recommendations .product-recommendations__inner ul').length > 0) {
            $('#shopify-section-product-recommendations .product-recommendations__inner ul').owlCarousel({
                loop: true,
                nav: false,
                dots: false,
                margin: 48,
                responsive: {
                    0: {
                        items: 2
                    },
                    768: {
                        items: 3
                    },
                    1024: {
                        items: 4
                    }
                }
            });
            clearInterval(interval_obj);
        }
    }, 1000);

    // FUNCTION ALIGN HEIGHT
    function alignHeight(selector) {
      jQuery(selector).css('height', '');
      var minHeight = 0;
      jQuery(selector).each(function () {
          if (minHeight < jQuery(this).outerHeight()) {
              minHeight = jQuery(this).outerHeight();
          }
      });
      if (minHeight > 0) {
          jQuery(selector).css('height', minHeight);
      }
    }

    // SLIDER ON MOBILE OF SECTION LIST BANNER
    jQuery('document').ready(function() {
        if (jQuery('.collection-header .section-list-banner').length && jQuery(window).width() < 768) {
            jQuery('.collection-header .section-list-banner .product-item').addClass('owl-carousel').owlCarousel({
                items: 1,
                margin: 16,
                nav: false,
                dots: false,
                stagePadding: 24,
                loop: true
            });
        }
        alignHeight('.collection-header .section-list-banner .product-item .item .title-content h3');
        jQuery(window).resize(function() {
            setTimeout(function() {
                alignHeight('.collection-header .section-list-banner .product-item .item .title-content h3');
            }, 200);
        });
    });

    // align height title product grid
    alignHeight('.collection-products-wrapper .grid--view-items .grid__item .product-card .grid-view-item__title');
    $(window).resize(function() {
      setTimeout(function() {
        alignHeight('.collection-products-wrapper .grid--view-items .grid__item .product-card .grid-view-item__title');
      }, 200);
    });
    // align height title blog
    alignHeight('.grid--blog .article__link .article__title');
    $(window).resize(function() {
      setTimeout(function() {
        alignHeight('.grid--blog .article__link .article__title');
      }, 200);
    });


    $('.btn-readmore-desc').click(function(e) {
      e.preventDefault();
      $(this).closest('.short-desc').addClass('hide');
    });
    /*Select Product*/
    $(".product_option .list_option .item_option a").on("click", function (e) {
        event.preventDefault();
        option_selected = $(this).data("value");
        group_selected = $(this).parents(".product_option").data("index");
        $(".product_option[data-index='" + group_selected + "'] .list_option .item_option a").removeClass('active');
        $(this).addClass('active');
        $(".product-form__input[data-index='" + group_selected + "']").val(option_selected).change();
    });
    /* Quanty product page */
    $(document).click(function (e) {
        var t = $(e.target),
            pQ = t.closest('.product-form__item--quantity .plus_quanty'),
            mQ = t.closest('.product-form__item--quantity .minus_quanty');
        if (pQ.length) {
            var input = pQ.parent().find('input[name="quantity"]'),
                oldQty = input.val();
            if (oldQty == "") {
                oldQty = 0;
            }
            newQty = parseInt(oldQty) + 1;
            input.val(newQty);
        }
        if (mQ.length) {
            var input = mQ.parent().find('input[name="quantity"]'),
                oldQty = input.val(),
                newQty = parseInt(oldQty) - 1;
            if (newQty > 0) {
                input.val(newQty);
            }
        }
    })
    /* Dropdown content product*/
    $(".content_product h4").on("click", function () {
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    });
    // close form form-message
    $('.form-message i.fa-times').click(function () {
        $(this).parent().hide();
    })

    // read more cms page
    if ($(window).width() < 767) {
        function AddReadMore() {
            var carLmt = 95;
            var readMoreTxt = "Read more";
            // Text to show when text is expanded
            var readLessTxt = "Read less";
            var allstr = $(".banner .content p").text();
            if (allstr.length > carLmt) {
                var firstSet = allstr.substring(0, carLmt);
                var secdHalf = allstr.substring(carLmt, allstr.length);
                var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
                $(".banner .content p").html(strtoadd);
            }
            //Read More and Read Less Click Event binding
            $(document).on("click", ".readMore,.readLess", function () {
                $(this).closest(".banner .content p").toggleClass("showlesscontent showmorecontent");
            });
        }
        AddReadMore();
    }

    /* Add active when element has focus */
    //checkbox
    var input_selector = 'input[type=checkbox], input[type=radio]';
    $(input_selector).each(function () {
        selectId = $(this).attr('id')
        $('label[for="' + selectId + '"]').addClass('checkbox_radio');
    });
    //select
    var selectId = $("select").each(function () {
        selectId = $(this).attr('id')
        $('label[for="' + selectId + '"]').addClass('active');
        $('label[for="' + selectId + '"]').addClass('focusing');
    });
    //input
    function updateTextFields(input_selector) {
        setTimeout(function () {
            $(input_selector).each(function (index, element) {
                var $this = $(this);
                var inputId = $this.attr('id');
                if ($(element).val().length > 0 || $(element).is(':focus') || element.autofocus) {
                    $('label[for="' + inputId + '"]').addClass('active');
                } else if ($(element)[0].validity.badInput) {
                    $('label[for="' + inputId + '"]').toggleClass('active', $(element)[0].validity.badInput === true);
                } else {
                    $('label[for="' + inputId + '"]').removeClass('active');
                }
                if ($(element).is(':focus')) {
                    $('label[for="' + inputId + '"]').addClass('focusing');
                } else {
                    $('label[for="' + inputId + '"]').removeClass('focusing');
                }
                if ($(element).is(':-webkit-autofill')) {
                    $('label[for="' + inputId + '"]').addClass('focusing');
                } else {
                    $('label[for="' + inputId + '"]').removeClass('focusing');
                }
            });
        }, 300);

    };
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], textarea';
    updateTextFields(input_selector);
    $(document).on('change', input_selector, function () {
        var inputId = $(this).attr('id');
        if ($(this).val().length !== 0 || $(this).attr('placeholder') !== undefined) {
            $('label[for="' + inputId + '"]').addClass('active');
        }
    });
    $(document).on('focus', input_selector, function () {
        var inputId = $(this).attr('id');
        $('label[for="' + inputId + '"]').addClass('active');
        $('label[for="' + inputId + '"]').addClass('focusing');
        $(this).siblings('.prefix').addClass('active');
    });
    $(document).on('blur', input_selector, function () {
        var $inputElement = $(this);
        var selector = ".prefix";
        var inputId = $(this).attr('id');
        if ($inputElement.val().length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === undefined) {
            $('label[for="' + inputId + '"]').removeClass('active');
        }
        $('label[for="' + inputId + '"]').removeClass('focusing');
        $inputElement.siblings(selector).removeClass('active');
    });
    /*Popup gallery*/
    $("#popup_gallery_button").on("click", function () {
        $("body").addClass('show_popup');
        $(".popup_gallery").addClass('active');
    });
    $(".popup_gallery .head_gallery i").on("click", function () {
        $("body").removeClass('show_popup');
        $(".popup_gallery").removeClass('active');
    });
    /*Popup sizeguide*/
    $("#popup-size-guide").on("click", function () {
        $("body").addClass('show_popup');
        $(".size_guide").addClass('active');
    });
    $(".size_guide .head_size_guide i").on("click", function () {
        $("body").removeClass('show_popup');
        $(".size_guide").removeClass('active');
    });
    $(".size_guide .head_size_guide h2").on("click", function () {
        var tabsizeguide = $(this).data("tabsizeguide");
        $(".size_guide .head_size_guide h2").removeClass('active');
        $(this).addClass('active');
        $(".size_guide .content_size_guide .text_size").removeClass('active');
        $(".size_guide .content_size_guide .text_size[data-tabsizeguide='" + tabsizeguide + "']").addClass('active');
    });
    $(".size_guide .content_size_guide .content_tab_img_size .titt h3").on("click", function () {
        var image = $(this).data("image");
        $(".size_guide .content_size_guide .content_tab_img_size .titt h3").removeClass('active');
        $(this).addClass('active');
        $(".size_guide .content_size_guide .content_tab_img_size .cont img").removeClass('active');
        $(".size_guide .content_size_guide .content_tab_img_size .cont img[data-image='" + image + "']").addClass('active');
    });
    // cart input
    $('.decrease-qty').on('click', function () {
        var count = $(this).siblings(".cart__qty-input");
        var val = parseInt(count.val());
        if (val > 1)
            count.val(val - 1);
    });
    $('.increase-qty').on('click', function () {
        var count = $(this).siblings(".cart__qty-input");
        var val = parseInt(count.val());
        count.val(val + 1);
    });
    widthscreen = $(window).width();
    $('.form-message').prepend('<i class="fal fa-times"></i>');
    $(document).on('click', '.form-message i', function () {
        $(this).parent().remove();
    });
    // function click dropdown menu
    $(document).on("click", ".mobile-nav-wrapper .mobile-nav__item .dropdown-menu-item", function () {
            $(this).next().slideToggle();
    });
    //function debounce for input search
    function debounce(func, wait, immediate) {
        var timeout;
        return function executedFunction() {
        var context = this;
        var args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
        };
    };

    var handleKeyup = debounce(function (e) {
        searchTeam();
    }, 500);

    //ajax search
    function searchTeam() {
        var inputVal = $('#search-team-input').val();
        if (inputVal != '') {
        $('.search-team-result .team-list').addClass('ajax-load');
        $('.search-team-result').show();
        $('#search-team-input').addClass('active');
        $.ajax({
            type: 'GET',
            url: '/collections/teams?view=ajax',
            success: function(response) {
            $('.search-team-result .team-list').html('');
            var teamsHtml = '';
                teamsHtml = $(response).find('.team-products li');
            if (teamsHtml.length) {
                var isEmpty = true;
                teamsHtml.each(function() {
                if ($(this).children('.team-name').text().toLowerCase().indexOf(inputVal.toLowerCase()) >= 0) {
                    isEmpty = false;
                    $('.search-team-result .team-list').append('<li>'+ $(this).html() + '</li>');
                }
                });
                if (isEmpty) {
                $('.search-team-result .team-list').html('<li class="no-result">No result...</li>');
                }
            } else {
                $('.search-team-result .team-list').html('<li class="no-result">No result...</li>');
            }
            $('.search-team-result .team-list').removeClass('ajax-load');
            },
            error: function(XMLHttpRequest) {
            $('.search-team-result .team-list').removeClass('ajax-load');
            //get message error in api ajax default Shopify
            var data = eval('(' + XMLHttpRequest.responseText + ')');
            var errorMessage = '';
            if (!!data.message) {
                errorMessage = data.description
            } else {
                errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
            }
            $(".alert_addtocart .error_p").text(errorMessage);
            $(".alert_addtocart").addClass('active error');
            }
        });
        } else {
        $('.search-team-result').hide();
        $('#search-team-input').removeClass('active');
        }
    }
    $('#search-team-input').on('keyup', function() {
        handleKeyup();
    });
    $('.btn-search-team').click(function(e) {
        e.preventDefault();
        searchTeam();
    });
    $('.btn-search-team-header').click(function(e) {
        e.preventDefault();
        $('#search-team-input').toggleClass('show');
        $('.icon_searchininput').toggleClass('showw');
        $(this).toggleClass('show');
        if (!$(this).hasClass('show')) {
            $('.search-team-result').hide();
            $('#search-team-input').val('');
        }
    });

    /* SELLER PROFILE PAGE */
    //align height
    alignHeight('.collection-products-wrapper .grid--view-items .grid__item .product-card .grid-view-item__title');
    $(window).resize(function() {
      setTimeout(function() {
        alignHeight('.collection-products-wrapper .grid--view-items .grid__item .product-card .grid-view-item__title');
      }, 200);
    });

    //move banners to top
    var bannerInterval = setInterval(function() {
      if ($('.mp_sp_page .toolbar-top-wrapper').length) {
        $('.section-list-banner').insertAfter('.toolbar-top-wrapper');
        $('.section-list-banner .product-item').trigger('refresh.owl.carousel');
        $('.mp-breadcrumb a').first().attr('href','/pages/search');
        clearInterval(bannerInterval);
      }
    }, 1000);

    //ajax Add to cart
    function reInitMinicart(url) {
      $.ajax({
        url: url,
        type: "GET",
        dataType: 'html',
        success: function(response) {
          //get and chang number item in icon cart
          var headerCartHtml = $(response).find('.site-header__cart').first().html();
          if (headerCartHtml) {
            $('.site-header .site-header__cart').html(headerCartHtml);
          }
        }
      });
    }

    //handle error
    function handleError(XMLHttpRequest) {
      //get message error in api ajax default Shopify
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      var errorMessage = '';
      if (!!data.message) {
        errorMessage = data.description
      } else {
        errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
      }
      $(".alert_addtocart .error_p").text(errorMessage);
      $(".alert_addtocart").addClass('active error');
    }


    //ajax add to cart on seller profile page
    $(document).on('click', '.btn-ajax-atc', function(e) {
      e.preventDefault();
      var self = $(this);
      var href = self.attr('href');
      $.ajax({
	      type: 'GET',
	      url: href,
	      success: function(response) {
	      	self.addClass('btn-loader');
          var productType = $(response).find('.product-info').first().data('type');
          if ('simple' == productType) {
            var firstVariantId = $(response).find('.product-info').first().data('first-variant-id');
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              xhrFields: {
                withCredentials: true
              },
              data: {
                id: firstVariantId, 
                quantity: 1
              },
              dataType: 'json',
              success: function(data) {
                self.removeClass('btn-loader');
                $(".alert_addtocart").addClass('active success');
                reInitMinicart(data.url);
              },
              error: function(XMLHttpRequest) {
                handleError(XMLHttpRequest);
              }			
            });
          } else {
            var quickView = $(response).find('.product-quickview-container').first().html();
            $.fancybox.open(quickView,{touch: false});
            $('.gp-product-detail.fancybox-content .owl-carousel').owlCarousel({
              items: 1,
              nav: true,
              navText: ["<i class='fal fa-chevron-left'></i>","<i class='fal fa-chevron-right'></i>"],
              loop:true,
              dots: false
            });
          }
        },
        error: function(XMLHttpRequest) {
          self.removeClass('btn-loader');
          handleError(XMLHttpRequest);
        }
      });
    });

    //update price when choose product option in quickview
    $(document).on('change', 'form.product-form-quickview select.single-option-selector-quickview', function() {
      var val = '';
      $('form.product-form-quickview select.single-option-selector-quickview').each(function() {
        if (val == '') {
          val += $(this).val();
        } else {
          val += ' / ' + $(this).val();
        }
      });
      if (val != '') {
        var available = false;
        $('form.product-form-quickview select#ProductSelect-quickview option').each(function() {
          if (val == $(this).text().trim()) {
            available = true;
            var optionValue = $(this).val();
            $('form.product-form-quickview select#ProductSelect-quickview').val(optionValue).change();
            // price
            var vPrice = parseInt($(this).data('price'));
            var vComparePrice = parseInt($(this).data('compare-at-price'));
            var priceHtml = '';
            if (vComparePrice > vPrice) {
              priceHtml = '<dl class="price price--on-sale" data-price=""><div class="price__regular"><dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt><dd><span class="price-item price-item--regular" data-regular-price=""><span class="money">'+ Shopify.formatMoney(vComparePrice) +'</span></span></dd></div><div class="price__sale"><dt><span class="visually-hidden visually-hidden--inline">Sale price</span></dt><dd><span class="price-item price-item--sale" data-sale-price=""><span class="money">'+ Shopify.formatMoney(vPrice) +'</span></span><span class="price-item__label" aria-hidden="true">Sale</span></dd></div></dl>';
            } else {
              priceHtml = '<dl class="price" data-price=""><div class="price__regular"><dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt><dd><span class="price-item price-item--regular" data-regular-price=""><span class="money">'+ Shopify.formatMoney(vPrice) +'</span></span></dd></div><div class="price__sale"><dt><span class="visually-hidden visually-hidden--inline">Sale price</span></dt><dd><span class="price-item price-item--sale" data-sale-price=""><span class="money">'+ Shopify.formatMoney(vPrice) +'</span></span><span class="price-item__label" aria-hidden="true">Sale</span></dd></div></dl>';
            }
            if (priceHtml != '') {
              $('.gp-product-detail.fancybox-content .product-info-price').html(priceHtml);
            }
          }
        });
        // available
        var addToCartBtn = $('.product-form-quickview .btn-add-to-cart-product-page');
        var soldOutBtnText = addToCartBtn.data('text-soldout');
        var addToCartBtnText = addToCartBtn.data('text-add-to-cart');
        if (!available) {
          addToCartBtn.prop('disabled', true);
          if (soldOutBtnText && soldOutBtnText != '') {
            addToCartBtn.find('span').text(soldOutBtnText);
          }
        } else {
          addToCartBtn.prop('disabled', false);
          if (addToCartBtnText && addToCartBtnText != '') {
            addToCartBtn.find('span').text(addToCartBtnText);
          }
        }
      }
    });

    //update select when click on an option on quickview
    $(document).on('click', '.gp-product-detail.fancybox-content .product_option .list_option .item_option a', function(e) {
      event.preventDefault();
      option_selected = $(this).data('value');
      group_selected = $(this).parents('.product_option').data('index');
      $('.product_option[data-index="'+group_selected+'"] .list_option .item_option a').removeClass('active');
      $(this).addClass('active');
      $('.gp-product-detail.fancybox-content .product-form__input[data-index="'+group_selected+'"]').val(option_selected).change();
  	});

    //add to cart action on quickview popup
    $(document).on('submit', 'form.product-form-quickview', function(e) {
      e.preventDefault();
      $(".quickview_alert_addtocart").removeClass('active error');
      var vId = $(this).find('select.product-form__variants').first().val();
      var qty = $(this).find('#Quantity-quickview').first().val();
      if (vId && qty > 0) {
        var btn = $(this).find('.btn-add-to-cart-product-page').first();
        btn.addClass('btn-loader');
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: 'quantity='+ qty +'&id=' + vId,
          dataType: 'json',
          xhrFields: {
            withCredentials: true
          },
          success: function(data) {
            btn.removeClass('btn-loader');
            $(".quickview_alert_addtocart").addClass('active success');
            reInitMinicart(data.url);
          },
          error: function(XMLHttpRequest, textStatus) {
            btn.removeClass('btn-loader');
            //get message error in api ajax default Shopify
            var data = eval('(' + XMLHttpRequest.responseText + ')');
            var errorMessage = '';
            if (!!data.message) {
              errorMessage = data.description
            } else {
              errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
            }
            $(".quickview_alert_addtocart .error_p").text(errorMessage);
            $(".quickview_alert_addtocart").addClass('active error');
          }
        });
      } else {
        $(".quickview_alert_addtocart .error_p").text("The number of products must be greater than 0");
        $(".quickview_alert_addtocart").addClass('active error');
      }
    });

    //toggle filter desktop
    $(document).on('click', '.mp-toggle-filter', function() {
      $(this).toggleClass('active');
      $('.wk-filter-desktop, .wk-filter-mobile').toggleClass('active');
      $('.mp-close-filter-mobile').toggleClass('active');
    });

    //toggle filter mobile
    $(document).on('click', '.mp-close-filter-mobile', function() {
      $(this).toggleClass('active');
      $('.mp-toggle-filter, .wk-filter-desktop, .wk-filter-mobile').removeClass('active');
    });

    //close filter desktop when click outside
    $(document).mouseup(function(e) {
      if ($(window).width() > 767) {
        var container = $('.mp-toggle-filter');
        var container2 = $('.wk-filter-desktop');
        if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
          $('.mp-toggle-filter, .wk-filter-desktop').removeClass('active');
        }
      }
    });

    // SLIDER ON MOBILE OF SECTION LIST BANNER ON SELLER PROFILE PAGE
    alignHeight('.template-mp_seller_profile .section-list-banner .product-item .item .title-content h3');
    jQuery(window).resize(function() {
        setTimeout(function() {
            alignHeight('.template-mp_seller_profile .section-list-banner .product-item .item .title-content h3');
        }, 200);
    });
    if (jQuery('.template-mp_seller_profile .section-list-banner').length && jQuery(window).width() < 768) {
        jQuery('.template-mp_seller_profile .section-list-banner .product-item').addClass('owl-carousel').owlCarousel({
            items: 1,
            margin: 16,
            nav: false,
            dots: false,
            stagePadding: 24,
            loop: true
        });
    }
    /* END SELLER PROFILE PAGE */
});